export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return String(iso);
  return d.toLocaleString("en-IN", { day: "2-digit", month: "short", ...(d.getFullYear() !== new Date().getFullYear() ? { year: "numeric" } : {}), hour: "numeric", minute: "2-digit" });
};

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—";

// Task due label: date only (Today / Tomorrow / 22 Oct), plus time for calls & meetings
export function fmtDue(t) {
  if (!t?.due) return "no due date";
  const d = new Date(t.due);
  if (isNaN(d)) return String(t.due);
  const IST = 330 * 60000, day = (x) => Math.floor((x + IST) / 86400000);
  const n = day(d.getTime()) - day(Date.now());
  const date = n === 0 ? "Today" : n === 1 ? "Tomorrow" : n === -1 ? "Yesterday"
    : d.toLocaleDateString("en-IN", { day: "numeric", month: "short", ...(d.getFullYear() !== new Date().getFullYear() ? { year: "numeric" } : {}), timeZone: "Asia/Kolkata" });
  return date;
}

export function fmtRel(iso) {
  if (!iso) return "—";
  const diff = (new Date(iso).getTime() - Date.now()) / 1000;
  const abs = Math.abs(diff);
  const unit = abs < 3600 ? [Math.round(abs / 60), "m"] : abs < 86400 ? [Math.round(abs / 3600), "h"] : [Math.round(abs / 86400), "d"];
  return diff >= 0 ? `in ${unit[0]}${unit[1]}` : `${unit[0]}${unit[1]} ago`;
}

// "late" = due on an earlier day (red), "today" = due today (yellow), "" otherwise
export function dueTone(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  const IST = 330 * 60000;
  const start = new Date(Math.floor((Date.now() + IST) / 86400000) * 86400000 - IST);
  const end = new Date(start.getTime() + 86400000);
  return d < start ? "late" : d < end ? "today" : "";
}
export const DUE_TEXT = { late: "text-[var(--breach)] font-medium", today: "text-[var(--warn)] font-medium" };

export const inr = (n) =>
  n ? "₹" + Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 }) : "—";

export const initials = (s) =>
  (s || "?").split(/[@.\s]/).filter(Boolean).slice(0, 2).map((x) => x[0]?.toUpperCase()).join("");
